const items = [
  "Full-stack",
  "UI / UX",
  "React",
  "TypeScript",
  "Product",
  "Design systems",
  "Cloudflare",
  "Motion",
];

/** A loud, scrolling colour band — pure fun between the hero and the work. */
export function Marquee() {
  const row = [...items, ...items];
  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee__track">
        {row.map((label, i) => (
          <span className="marquee__item" key={i}>
            {label}
            <i>✦</i>
          </span>
        ))}
      </div>
    </div>
  );
}
